import commonFn from '@/assets/javascripts/common_function.js';
import clientConfig from '@/config';
import { getCommonHeaders } from '@/utils/request';
import { getToken } from '@/utils/auth'; // get token from cookie

/**
 * el-upload 量身定制
 *   <el-upload
        :file-list="fileList"
        :action="actionUrl"
        :headers="uploadHeaders"
        :accept="acceptByType"
        :limit="limit"
        :on-exceed="handleExceed"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeFileUpload"
        :on-change="handleFileChange"
        :on-remove="handleFileRemove"
        :before-remove="beforeRemove"

        data中需要指定 acceptByType  acceptType:'img' 会自动映射为 .jpg,.png等
        或者自定义格式: customAccept:  ['jpg', 'mp4'],
  </el-upload>
 */
const originAcceptsMap = {
  // todo 完善其他格式
  img: ['jpg', 'jpeg', 'png', 'svg'],
  video: ['mp4', 'avi', 'mkv', 'flv'],
};

// 转换为el组件识别的格式
// 需要转换大小写, 分割 如 '.jpg,.jpeg,.png,.JPG,.JPEG'
const elAcceptsMap = {};
_.forEach(originAcceptsMap, function (list, key) {
  elAcceptsMap[key] = _.flatten(
    list.map(type => {
      return ['.' + type, '.' + type.toUpperCase()];
    })
  ).join(',');
});

const limitTypeJudgeMap = {
  // from https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Basics_of_HTTP/MIME_types
  // todo 完善其他格式
  img: mineType => mineType.includes('image'),
  video: mineType => mineType.includes('video'),
};

export default {
  data() {
    return {
      limit: 3,
      acceptType: '',
      customAccept: '', // 自定义 '.svg, .mp4'
      mytoken: '',
      fileList: [],
      maxFileSize: 10, // 100MB
    };
  },
  mounted() {
    this.mytoken = getToken();
  },
  methods: {
    handleFileChange(file, fileList) {
      // 同步状态
      this.fileList = _.cloneDeep(fileList);
    },
    handleFileRemove(file, fileList) {
      // 同步状态
      this.fileList = _.cloneDeep(fileList);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      if (this.rejectUploadFlag && !this.needDelConfirm) {
        // call by reject...
        this.rejectUploadFlag = false;
        return true;
      }

      return this.$confirm(`确定移除${file.name}？`);
    },
    handleUploadSuccess: _.debounce(
      function (res, file, fileList) {
        if (res.success) {
          this.$message.success('上传成功');
        } else {
          // 上传失败
          const index = fileList.findIndex(item => item === file);
          if (index !== -1) {
            fileList.splice(index, 1);
          }
          this.$message.warning(res.message || '上传失败');
        }
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    handleUploadError(err, file, fileList) {
      this.$message.error(err.message);
    },
    beforeFileUpload(file) {
      let isAcceptFileType = false;
      if (this.customAccept) {
        // 自定义格式校验, 校验文件格式
        // /.*\.(.+)/ 'a.b.c.d' => .d
        const res = file.name.match(/.*\.(.+)/);
        const format = res ? res[1] : '';
        isAcceptFileType = format
          ? this.customAccept.includes(format.toLowerCase())
          : false; // 无格式
      } else if (this.acceptType) {
        // 会检测MINE
        isAcceptFileType = limitTypeJudgeMap[this.acceptType](file.type);
      }

      // 文件大小
      const isLtSize = this.maxFileSize
        ? file.size / 1024 / 1024 < this.maxFileSize
        : true; // 0则不检验

      let validOnce = false; // 只校验第一个错误, 如果有3+个校验,需要优化写法
      if (!isAcceptFileType) {
        validOnce = true;
        this.$message.error('文件格式不正确!');
      }
      if (!validOnce && !isLtSize) {
        validOnce = true;
        this.$message.error(`文件大小不能超过 ${this.maxFileSize}M!`);
      }
      // would call onRemove -- https://github.com/ElemeFE/element/issues/8926
      this.rejectUploadFlag = true;
      return !validOnce;
    },
  },
  computed: {
    // 将用户传的转数据, 让用户可以方便填写
    customAcceptWithDot() {
      return this.customAccept ? this.customAccept.map(t => `.${t}`) : null;
    },
    imageUrl: function () {
      return this.$http.defaults.imgBasicUrl;
    },
    actionUrl: function () {
      // 上传附件图片路径
      return this.$http.defaults.baseURL + clientConfig.uploadUrl;
    },
    acceptByType() {
      return this.customAcceptWithDot
        ? this.customAcceptWithDot.join(',')
        : elAcceptsMap[this.acceptType];
    },
    uploadHeaders() {
      return {
        ...getCommonHeaders(),
        ContentType: 'multipart/form-data',
      };
    },
  },
};
